module.exports = __webpack_public_path__ + "static/img/icon-mp4_filled.79398330.svg";